import { useState, useEffect } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';
import { Input, Icon, Dropdown, Button, Form } from 'semantic-ui-react';

import { accomodationTypes, categorie } from './utils';
import { getRoss1000Strutture } from 'iovisit-reggioemiliawelcome/actions/ross1000strutture';
import ElencoStrutture from './ElencoStrutture';
import { getRoss1000Comuni } from 'iovisit-reggioemiliawelcome/actions/ross1000comuni';

const Body = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const initialData = {
    nome: '',
    tipo: '',
    categoria: '',
    comune: '',
  };

  const [ross1000data, setRoss1000Data] = useState(initialData);

  const filterChange = (field, value) => {
    setRoss1000Data((prev) => ({ ...prev, [field]: value }));
  };

  const doSearch = () => {
    // if (JSON.stringify(ross1000data) !== JSON.stringify(initialData)) {
    dispatch(getRoss1000Strutture(ross1000data));
    // }
  };

  const resetFilters = () => {
    setRoss1000Data(initialData);
    dispatch(getRoss1000Strutture(initialData));
  };

  const selectedCategoria = categorie[ross1000data.tipo];
  const comuni = useSelector((state) => state.ross1000comuni.result) ?? [];

  useEffect(() => {
    dispatch(getRoss1000Comuni());
  }, []);

  return (
    <div className="ross1000strutture">
      {/* <div className={'iv--search-filters search_type_ross1000'}> */}
      <Form
        onSubmit={doSearch}
        className={'iv--search-filters search_type_ross1000'}
      >
        <div className="filters">
          {/* nome struttura */}
          <div className="iv--filter">
            <div className="iv--search-filter-text">
              <Input
                placeholder={intl.formatMessage(messages.ross1000_name_ph)}
                aria-label={intl.formatMessage(messages.ross1000_name_ph)}
                icon
                onChange={(e, data) => {
                  filterChange('nome', data.value);
                }}
                value={ross1000data.nome}
                aria-controls="search-results-region-sr"
                className="mt-0"
              />
              {ross1000data.nome !== '' && (
                <Button
                  type="button"
                  onClick={() => filterChange('nome', '')}
                  className="remove-filter"
                >
                  <Icon name="delete" />
                </Button>
              )}
            </div>
          </div>

          {/* tipo struttura */}
          <div className="iv--filter">
            <Dropdown
              placeholder={intl.formatMessage(messages.ross1000_tipo_ph)}
              aria-label={intl.formatMessage(messages.ross1000_tipo_ph)}
              className="iv--search-filter-select"
              clearable
              search
              selection
              options={accomodationTypes}
              value={ross1000data.tipo}
              onChange={(e, data) => {
                filterChange('tipo', data.value);
                if (ross1000data.categoria) {
                  filterChange('tipo', data.value);
                  filterChange('categoria', '');
                }
              }}
              aria-controls="search-results-region-sr"
            />
          </div>
          {/* categoria */}
          {selectedCategoria && selectedCategoria.length > 0 && (
            <div className="iv--filter">
              <Dropdown
                placeholder={intl.formatMessage(messages.ross1000_categoria_ph)}
                aria-label={intl.formatMessage(messages.ross1000_categoria_ph)}
                className="iv--search-filter-select"
                clearable
                search
                selection
                options={selectedCategoria}
                value={ross1000data.categoria}
                onChange={(e, data) => filterChange('categoria', data.value)}
                aria-controls="search-results-region-sr"
              />
            </div>
          )}
          {comuni?.length > 0 && (
            <div className="iv--filter">
              <Dropdown
                placeholder={intl.formatMessage(messages.ross1000_comune_ph)}
                aria-label={intl.formatMessage(messages.ross1000_comune_ph)}
                className="iv--search-filter-select"
                clearable
                search
                selection
                options={comuni}
                value={ross1000data.comune}
                onChange={(e, data) => filterChange('comune', data.value)}
                aria-controls="search-results-region-sr"
              />
            </div>
          )}
        </div>

        {/* bottone submit search */}
        <div className="buttons">
          <Button type="submit" primary>
            {intl.formatMessage(messages.ross1000_do_search_button)}
          </Button>
          <Button type="button" onClick={resetFilters}>
            {intl.formatMessage(messages.ross1000_reset_button)}
          </Button>
        </div>
      </Form>
      {/* </div> */}

      <ElencoStrutture />
    </div>
  );
};

export default Body;

const messages = defineMessages({
  ross1000_name_ph: {
    id: 'ross1000_name_ph',
    defaultMessage: 'Nome struttura',
  },
  ross1000_tipo_ph: {
    id: 'ross1000_tipo_ph',
    defaultMessage: 'Tipo struttura',
  },
  ross1000_categoria_ph: {
    id: 'ross1000_categoria_ph',
    defaultMessage: 'Categoria',
  },
  ross1000_comune_ph: {
    id: 'ross1000_comune_ph',
    defaultMessage: 'Comune',
  },
  ross1000_do_search_button: {
    id: 'ross1000_do_search_button',
    defaultMessage: 'Cerca',
  },
  ross1000_reset_button: {
    id: 'ross1000_reset_button',
    defaultMessage: 'Reset filtri',
  },
});
